import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export const useConsignadoINSS = () => {
    const navigate = useNavigate();
    const faqs = [
        {
            question: "Quem pode contratar o Empréstimo Consignado?",
            answer: "O Empréstimo Consignado está disponível para aposentados e pensionistas do INSS, servidores públicos, militares das Forças Armadas (conforme convênio), além de trabalhadores com carteira assinada vinculados a empresas conveniadas (consignado privado).",
        },
        {
            question: "Qual é a taxa de juros do Empréstimo Consignado?",
            answer: "As taxas de juros variam conforme o convênio. Para o Empréstimo Consignado, os juros começam a partir de 1,85% ao mês. Já no caso do cartão de crédito consignado, a taxa parte de 2,46% ao mês.",
        },
        {
            question: "O que é margem consignável?",
            answer: "A margem consignável é o percentual máximo do salário ou benefício que pode ser comprometido com parcelas de crédito consignado. Atualmente, para beneficiários do INSS, esse limite é de 45%: sendo 35% para empréstimo consignado, 5% para cartão de crédito consignado e mais 5% para o cartão consignado benefício.",
        },
        {
            question: "Como desbloquear meu benefício do INSS para contratar o consignado?",
            answer: `• Passo 1 – Acesse o site https://meu.inss.gov.br ou o aplicativo “Meu INSS”;  
• Passo 2 – Vá em “Agendamentos/Solicitações”;  
• Passo 3 – Digite “desbloquear” na busca e selecione “Bloqueio/Desbloqueio de Benefício para Empréstimo”;  
• Passo 4 – Siga as instruções e forneça os dados solicitados para concluir a solicitação.`,
        },
        {
            question: "Posso contratar empréstimo mesmo sem margem disponível?",
            answer: "Sim. Aposentados, pensionistas do INSS e servidores públicos sem margem consignável podem contratar o Dinheiro Extra — um empréstimo pessoal emergencial. Para consultar a disponibilidade, entre em contato com nossa Central de Relacionamento: 0800 031 8866.",
        },
        {
            question: "O que é um Empréstimo Consignado?",
            answer: "É uma modalidade de crédito com juros reduzidos, ideal para quem precisa de dinheiro extra com rapidez. As parcelas são fixas e descontadas diretamente do salário ou benefício, garantindo mais segurança e controle financeiro.",
        },
        {
            question: "Existe cobrança antecipada para liberar o empréstimo?",
            answer: "Não. Nem o Banco Bmg, nem as lojas Help! ou correspondentes autorizados cobram qualquer valor antecipado para liberação do crédito. Desconfie de qualquer solicitação desse tipo.",
        },
        {
            question: "Posso quitar meu Empréstimo Consignado antes do prazo?",
            answer: "Sim. A quitação total ou parcial pode ser feita a qualquer momento, com redução proporcional dos juros conforme previsto no contrato. Para solicitar o boleto, entre em contato com a nossa Central de Atendimento: 0800 031 8866.",
        },
        {
            question: "Por que meu pedido de empréstimo pode ser recusado?",
            answer: "A liberação está sujeita a análise de crédito. Se seu pedido for recusado, recomendamos entrar em contato com o correspondente responsável ou ligar para nossa Central de Relacionamento: 0800 031 8866 para entender os motivos e verificar novas possibilidades.",
        },
        {
            question: "Como posso consultar o contrato do meu empréstimo?",
            answer: "Você pode consultar seu contrato ligando para a Central de Relacionamento no número 0800 031 8866 ou acessando: https://www.bancobmg.com.br/emprestimo/consulta-de-contratos.htm",
        }
    ];
    const [cpf, setCpf] = useState('');
    const personalDataModalRef = useRef();

    const getSubHeader = () => (<section style={{ zIndex: 5 }} className="hidden md:flex bg-[#462A71] w-full px-4 py-2 flex items-center justify-center gap-5 fixed">
        <a href="#AboutConsignadoINSS" className="text-white hover:opacity-[0.7] text-sm">Vantagens</a>
        <a href="#ConsignadoInfo" className="text-white hover:opacity-[0.7] text-sm">Consignado</a>
        <a href="#HowSolicitationConsignadoINSS" className="text-white hover:opacity-[0.7] text-sm">Como solicitar</a>
        <a href="#Faq" className="text-white hover:opacity-[0.7] text-sm">Ajuda</a>
    </section>)

    const openPersonalDataModal = () => {
        personalDataModalRef.current.openModal(cpf);
    }

    const onGoToRegister = () => navigate('/register');

    return {
        faqs,
        getSubHeader,
        setCpf,
        cpf,
        personalDataModalRef,
        openPersonalDataModal,
        onGoToRegister
    }
}